import { SpyneTrait, DomElement, ViewStream } from "spyne";
import { UtilTraits } from "traits/util-traits";

export class CodePlaygroundExamplesReferencesViewstreamTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = 'codeplaygroundRef$_VS_';
    super(context, traitPrefix);
  }

  static codeplaygroundRef$_VS_HelloWorld() {
    return 'Hello World';
  }

  static codeplaygroundRef$_VS_AppendToDom(props = this.props) {

    new ViewStream({
      data: "appendToDom",
      style: `background:#5ED0FA;\npadding:.5rem;`,
    }).appendToDom(this.props.el.contentDocument.body);

    return `
    import {ViewStream} from 'spyne';
    
    new ViewStream({
      data:  "appendToDom",
      style: \`background:#5ED0FA;
              \u200Bpadding:.5rem;\
              \`
            }).appendToDom(document.body);       

  `;
  }
  static codeplaygroundRef$_VS_PrependToDom(props = this.props) {

    new ViewStream({
      data: "prependToDom",
      style: `background:#5ED0FA;\npadding:.5rem;`,
    }).prependToDom(this.props.el.contentDocument.body);

    return `
    import {ViewStream} from 'spyne';
    
    new ViewStream({
      data:  "prependToDom",
      style: \`background:#5ED0FA;
              \u200Bpadding:.5rem;\
              \`
            }).prependToDom(document.body);       

  `;
  }

  static codeplaygroundRef$_VS_AppendToDomAfter(props = this.props) {

   // new ViewStream({data:'first-child'}).appendToDom(this.props.el.contentDocument.body)
   // new ViewStream({data:'last-child'}).appendToDom(this.props.el.contentDocument.body)

    new ViewStream({
      data: "prependToDom",
      style: `background:#D9E2EC; color:#52606D;\npadding:.5rem;`,
    }).prependToDom(this.props.el.contentDocument.body);

    new ViewStream({
      data: "appendToDomAfter",
      style: `background:#5ED0FA;\npadding:.5rem;`,
    }).appendToDomAfter(
        this.props.el.contentDocument.body.querySelector("div:first-child"));

    return `
    import {ViewStream} from 'spyne';
    
    new ViewStream({
      data:  "appendToDomAfter",
      style: \`background:#5ED0FA;
              \u200Bpadding:.5rem;\
              \`
            }).appendToDomAfter(
       document.body.querySelector(
        'div:first-child'
         ));     

  `;
  }
  static codeplaygroundRef$_VS_AppendToNull(props = this.props) {

    return `
  import { ViewStream } from 'spyne';

  class HiddenViewStream extends ViewStream {
    constructor() {
      super();
    }
  
    mySpecialMethod() {
   /* Perform logic here without \n     \u2009visibly rendering the component */
    }
  }
  
   // Create and append to hidden container
   new HiddenViewStream().appendToNull();
  `;
  }

}
